import {
    createSlice
} from '@reduxjs/toolkit';


// cat. define
import APP_CONFIG from '../configs/settings/app.config';
import {CONFIG_SYSTEM_DEFAULTS} from '../configs/settings/system.config';
import {parseSystemConfig} from '../utils/settingsParser';

const initialState = {
    APP_CONFIG: APP_CONFIG,

    // Server/runtime system settings.
    SYSTEM: CONFIG_SYSTEM_DEFAULTS,

    // Page/form defaults live in each component's _config.
    // Store keeps only server/runtime overrides.
    PAGE_VIEW_CONFIG: {},
    PAGE_FORM_CONFIG: {},
    SYSTEM_PAGE_VIEW_CONFIG: {},
    SYSTEM_PAGE_FORM_CONFIG: {},
};

const settingsReducer = createSlice({
    name: 'settings',
    initialState,
    reducers: {
        /**
         * app 설정 정보 초기화
         * @param {Object} action.payload - app 설정 정보 객체
         */
        initSettingsApp: (state, action) => {
            return {
                ...state,
                ...action.payload
            };
        },

        /**
         * page 설정 정보 초기화
         * @param {Object} action.payload - page 설정 정보 객체
         */
        initSettingsPage: (state, action) => {
            return {
                ...state,
                ...action.payload
            };
        },

        /**
         * 시스템 설정 초기화
         * 백엔드에서 받은 시스템 설정 override를 state에 반영
         *
         * 항상 CONFIG_SYSTEM_DEFAULTS 기준으로 재구성한다 — 현재 state 위에 병합하면
         * 서버에서 제거된 override 키가 세션 내 고착된다.
         *
         * @param {Object} state - 현재 상태
         * @param {Object} action - action 객체
         * @param {Object} action.payload - 시스템 설정 override 객체
         */
        initSettingsSystem: (state, action) => {
            state.SYSTEM = parseSystemConfig(action.payload);
        },

        /**
         * 시스템 설정 업데이트
         * initSettingsSystem과 동일한 병합 로직
         *
         * @param {Object} state - 현재 상태
         * @param {Object} action - action 객체
         * @param {Object} action.payload - 시스템 설정 override 객체
         */
        updateSettings: (state, action) => {
            state.SYSTEM = parseSystemConfig(action.payload);
        },
    },
});

export const {
    initSettingsApp,
    initSettingsPage,
    initSettingsSystem,
    updateSettings,
} = settingsReducer.actions;

export default settingsReducer.reducer;
